import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useRef } from 'react';
import theme from '../../../theme';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HotelMap(_ref) {
  var latitude = _ref.latitude,
    longitude = _ref.longitude,
    brand = _ref.brand,
    apiKey = _ref.apiKey,
    fillColor = _ref.fillColor;
  var hotelMapRef = useRef(null);
  useEffect(() => {
    var loader = new Loader({
      apiKey,
      version: 'weekly',
      libraries: []
    });
    loader.load().then(() => {
      if (hotelMapRef !== null && hotelMapRef !== void 0 && hotelMapRef.current && latitude && longitude) {
        var _google = window.google;
        var hotelMap = new _google.maps.Map(hotelMapRef.current, {
          center: {
            lat: latitude,
            lng: longitude
          },
          zoom: 13
        });
        new _google.maps.Marker({
          position: {
            lat: latitude,
            lng: longitude
          },
          map: hotelMap,
          icon: getMarkerIconByBrand()
        });
      }
    });
  }, [brand, latitude, longitude]);
  return _jsx(Box, {
    "data-testid": "hotelDirections-map",
    h: "full",
    ref: hotelMapRef
  });
  function getMarkerIconByBrand() {
    return _objectSpread(_objectSpread({}, defaultPinStyles), {}, {
      fillColor,
      anchor: new google.maps.Point(15, 30)
    });
  }
}
var MapPinPath = 'M45.0585 21C45.0585 32.598 22.8232 63.5 22.8232 63.5C22.8232 63.5 0.587891 32.598 0.587891 21C0.587891 9.40202 10.543 0 22.8232 0C35.1034 0 45.0585 9.40202 45.0585 21Z';
var defaultPinStyles = {
  path: MapPinPath,
  fillOpacity: 1,
  strokeWeight: 2,
  strokeColor: theme.colors.baseWhite,
  rotation: 0,
  scale: 0.5
};